import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  websiteContentIcon,
  seoContentIcon,
  adCopyContentIcon,
  personalBrandingContentIcon,
  podcastContentICon,
} from "../../../../assets/icons/serviceIcon/index";
import SocialMediaContentWork from "./SocialMediaContentWork";

const items = [
  {
    name: "Platform-Specific Strategy Planning",
    text: "Choose the right platforms, define goals for each one, and create a plan that fits your business, time, and audience.",
  },
  {
    name: "Content Pillar & Calendar Setup",
    text: "Organise your message with clear content themes, then build a calendar that keeps your content consistent, relevant, and easy to follow.",
  },
  {
    name: "Growth & Engagement Blueprint",
    text: "Create a clear plan to grow followers, boost interactions, and build a loyal audience through thoughtful content strategies.",
  },
];

const otherService = [
  {
    icon: seoContentIcon,
    name: "Seo Blog Writing",
    des: "Blog posts that teach, tell stories and rank on Google",
    path: "/seo-blog-writing",
  },
  {
    icon: adCopyContentIcon,
    name: "Ad Copy & Sales Funnels",
    des: 'Clear words that guide people from curiosity to clicking "yes"',
    path: "/ad-copy-and-sale-funnels",
  },
  {
    icon: websiteContentIcon,
    name: "Website Content",
    des: "Make your website speak your value in the simplest way",
    path: "/website-content",
  },
  {
    icon: personalBrandingContentIcon,
    name: "Personal Branding Content",
    des: "Bring your voice to life across everything your audience sees",
    path: "/personal-branding-content",
  },
  {
    icon: podcastContentICon,
    name: "Podcast Scripting & Editing",
    des: "Turn your ideas into podcasts that engage with your audience",
    path: "/podcast-scripting-and-editing",
  },
];
const SocialMediaContent = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Strategy"
        description="We help you show up online with clarity and purpose. From planning to content ideas, everything is built to grow your presence without the overwhelm."
        heading="Social Media"
      />
      <NewCommonServiceForm title="Social Media Strategy" items={items} />
      <SocialMediaContentWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default SocialMediaContent;
